jQuery(function($) {

var l_window = parseInt($(window).width());

/**********************************************************************/
/*************** MUSHROOM - HEADER FIXE ****************/
/**********************************************************************/

 var loycoRso = document.querySelector("header.site-header");
 

function isNavVisible(loycoRso) {
  return (loycoRso.classList.contains('open-s-menu') ? true : false );
}


var options = {
    offset : 60,

    // scroll tolerance in px before state changes
 //   tolerance : 0,
    // or you can specify tolerance individually for up/down scroll
    tolerance : {
        up : 5,
        down : 0
    },

  onUnpin: function() {
    if ( isNavVisible(loycoRso) ) {
      this.elem.classList.remove(this.classes.unpinned);
      this.elem.classList.add(this.classes.pinned);
    }
    else {
      this.elem.classList.add(this.classes.unpinned);
      this.elem.classList.remove(this.classes.pinned);
    }
  }
};

var headroom  = new Headroom(loycoRso,options);

// initialise
headroom.init();
	

/**********************************************************************/
/*************** NAV / MENU MOBILE // ADD BTN BACK ****************/
/**********************************************************************/

$( "ul.sub-menu" ).each(function( index ) {
  let txt_this_menu =  $( this ).parent().find(">:first-child").text();
  $(this).prepend( '<li class="btn-back">'+txt_this_menu+'</li>');
});

$( "ul.sub-menu > li.btn-back" ).on( "click", function() {
  $(this).parent().parent().removeClass('focus');
} );

/**********************************************************************/
/*************** INTRODUCTION / HOME PAGE / DIAPORAMA ****************/
/**********************************************************************/
	 
var swiper_PSIntro = new Swiper('.js-swiper-HomeIntro', {
  
	  slidesPerView: 1,
	  loop: true,
	  speed: 1000,
	  autoplay: {
	    delay: 6000,
	    disableOnInteraction: false
	  },
  //watchSlidesProgress: true,
});
  


 /**********************************************************************/
/*************** SLIDER  / SAVOIR FAIRE ****************/
/**********************************************************************/

	 var swiper_home_skills = new Swiper('.js-swiper-Skills', {

    slidesPerView: 1.4,
    loop: true,
    speed: 1000,
    spaceBetween: 16,
     centeredSlides: true,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false
    },
      breakpoints: {
        1025: { // a partir de 769
          slidesPerView: 2.8,
          spaceBetween: 40,
           centeredSlides: false,
        },
        601: { // a partir de 769
          slidesPerView: 1.8,
          spaceBetween: 32,
           centeredSlides: false,
        }
    },


    pagination: {
      el: ".Skills-Data-Pagination .swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: '.Skills-Data-Pagination .swiper-button-next',
      prevEl: '.Skills-Data-Pagination .swiper-button-prev',
    },

  //watchSlidesProgress: true,
});


/**********************************************************************/
/*************** ANIMATION AU SCROLL ****************/
/**********************************************************************/
	 


  /******************************************/
  /***** ANIMATIONS ACTIONS H1 ***/
  /******************************************/

     if ( $( ".HomeS2-Desc" ).length && l_window > 1024){  
    
      const line_home_s1 = gsap.utils.toArray('.HomeS2--lineg');
        var tr1 = gsap.from(line_home_s1,1,{
          delay:0.08,
          right: '100%',
          ease: "power1.out",
          scrollTrigger: {
            trigger:'.HomeS2-container',
             //start: "top bottom", // the default values
             end: "center end",
             scrub: true,
             //invalidateOnRefresh: true,
            //immediateRender:false,
            toggleActions: "restart pause resume restart",
          }, 
        });

        const img_home_s1 = gsap.utils.toArray('.HomeS2-Img');
        var tr2 = gsap.from(img_home_s1,1,{
          delay:0.08,
          top: '300px',
          ease: "power1.out",
          scrollTrigger: {
            trigger:'.HomeS2-container',
             //start: "top bottom", // the default values
             end: "center end",
             scrub: true,
             //invalidateOnRefresh: true,
            //immediateRender:false,
            toggleActions: "restart pause resume restart",
          }, 
        });
  
  }


 /******************************************/
  /***** ANIMATIONS ACTIONS S3 ***/
  /******************************************/

     if ( $( ".HomeS3" ).length && l_window > 1024) {  
    
      const line_home_s3 = gsap.utils.toArray('.HomeS3--vertical-lineg');
        var tr3 = gsap.from(line_home_s3,1,{
          delay:0.08,
          height:0,
          ease: "power0.out",
          scrollTrigger: {
            trigger:'.HomeS3',
             //start: "top bottom", // the default values
             end: "bottom end",
             scrub: true,
             //invalidateOnRefresh: true,
            //immediateRender:false,
            toggleActions: "restart pause resume restart",
          }, 
        });

  }

  /******************************************/
  /***** ANIMATIONS ACTIONS S4 ***/
  /******************************************/

     if ( $( ".HomeS4" ).length && l_window > 767) {  
    
      const suarre_s4 = gsap.utils.toArray('.HomeS4-L-bgsquarre');
        var s4s = gsap.from(suarre_s4,1,{
          delay:0.08,
          right:'100%',
          ease: "power4.out",
          scrollTrigger: {
            trigger:'.HomeS4-Desc',
             //start: "top bottom", // the default values
             end: "bottom end",
             scrub: true,
             //invalidateOnRefresh: true,
            //immediateRender:false,
            toggleActions: "restart pause resume restart",
          }, 
        });

  }

    /******************************************/
  /***** ANIMATIONS ACTIONS HOME S5 ***/
  /*************************************/


     if ( $( ".HomeS5" ).length && l_window > 1024) {  
    
      const line_home_s5 = gsap.utils.toArray('.HomeS5--vertical-lineg');
        var tr5 = gsap.from(line_home_s5,1,{
          delay:0.08,
          height:0,
          ease: "power0.out",
          scrollTrigger: {
            trigger:'.HomeS5',
             //start: "top bottom", // the default values
             end: "center end",
             scrub: true,
             //invalidateOnRefresh: true,
            //immediateRender:false,
            toggleActions: "restart pause resume restart",
          }, 
        });

  }

  gsap.utils.toArray(".animCounter").forEach(box_counter => {
  var tler =  gsap.from(box_counter, {
      textContent: "0",
      duration: 1,
      ease: "power4.inOut",
      modifiers: {
          textContent: value => formatNumber(value)
      },
      scrollTrigger: {
          trigger: box_counter,
          start: "100px 100%",
          end: "+=100",
          toggleActions: "play none none reset"
      }
  }); });


function formatNumber(value) {
   //let s = (+value).toLocaleString('en-US').split(".");
   //return decimals ? s[0] + "." + ((s[1] || "") + "00000000").substr(0, decimals) : s[0];
	return parseInt(value);
}


    /******************************************/
  /***** SINGLE REA ***/
  /*************************************/
  
   /***** SINGLE REA 1/ Toggle more skills ***/
  /*************************************/

    $( ".toggle-more-skills" ).on( "click", function() {
      if($(this).attr('aria-expanded') == "false"){
        $(this).attr('aria-expanded', "true");
        $(this).html('<i class="icon-close"></i>');
      }else{
         $(this).attr('aria-expanded', "false");
        $(this).html($(this).attr('data-txt'));
      }

      $("#more-skills" ).slideToggle(500);

  });


 /**********************************************************************/
/*************** GALERIE IMAGE / SINGLE REA ****************/
/**********************************************************************/
   
var swiper_galleryRea = new Swiper('.js-swiper-ReaGallerie', {
    slidesPerView: 1,
    loop: true,
    speed: 1000,
    spaceBetween: 16,
     centeredSlides: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    pagination: {
      el: ".Skills-Data-Pagination .swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: '.Skills-Data-Pagination .swiper-button-next',
      prevEl: '.Skills-Data-Pagination .swiper-button-prev',
    },
  //watchSlidesProgress: true,
});
  
  
  /*************** GALERIE OTHER REA ****************/
/**********************************************************************/
   
    var swiper_other_rea = new Swiper('.js-swiper-Orea', {

    slidesPerView: 1.4,
    loop: true,
    speed: 1000,
    spaceBetween: 16,
    centeredSlides: true,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false
    },
      breakpoints: {
        769: { // a partir de 769
          slidesPerView: 3,
          spaceBetween: 32,
           centeredSlides: false,
           loop: true,
        },
        601: { // a partir de 769
          slidesPerView: 2.3,
          spaceBetween: 32,
          loop: true,
          centeredSlides: true,
        }
    },
  //watchSlidesProgress: true,
});
    

  /*************** ANIMATION HEADER REALISATIONS ****************/
/**********************************************************************/
   

   const headerPage = gsap.utils.toArray('.classic-page-header');
        headerPage.forEach((bloc) => {
          gsap.from(bloc, {
            scrollTrigger: {
              start: 'top bottom',
              end: 'bottom top',
              trigger: bloc,
              toggleClass: 'enable'
            }
          });
    });



      /********************* START / REAS FILTER ****************************
      ****************************************************************/

          $('#search_rea button').on('click',function(){
             return false;
        });


          if(l_window < 767) $('.SingleEvtMain-R .js-Tabs-Inner-Content').hide();
          $(".js-Tabs-Inner-Title").click(function() {
               var parentActiveTab = $(this).parent().parent().attr('data-tabs-id');
              if($(this).next().css('display') == 'none'){
                  $(parentActiveTab+" .js-Tabs-Inner-Content").hide();
                  var d_activeTab = $(this).attr("rel"); 
                  $("#"+d_activeTab).fadeIn();
                
                $(parentActiveTab+" .js-Tabs-Inner-Title").removeClass("d_active");
                  $(this).addClass("d_active");
                
                $(parentActiveTab+" .Tabs-Liste li").removeClass("active"); // inutile pour footer mais utile pour global tabs
                $(parentActiveTab+" .Tabs-Liste li[rel^='"+d_activeTab+"']").addClass("active");  // inutile pour footer mais utile pour global tabs
            }else{
              $(this).next().slideUp(400);
              $(parentActiveTab+" .js-Tabs-Inner-Title, .Tabs-Liste li").removeClass("d_active");  // inutile pour footer mais utile pour global tabs
            }
            });

      /*********************** END / REA FILTERS **************************
       * ****************************************************************/



       /*********************************/
          /** ISOTOPE POUR LES REAS dans la page ALL REA **/
        /*********************************/

             /* Masonry Project archive */  
        var $container_rea_masonry = $('.masonry-rea');
        var grid_isotope;
        var class_filter_init = '*';
       
       // if(string_value.type_filter_rea != '*') class_filter_init = '.'+string_value.type_filter_rea;
        $container_rea_masonry.imagesLoaded(function () {
            grid_isotope = $container_rea_masonry.isotope({
                itemSelector: '.resume-item-rea',
                percentPosition: true,
                filter:class_filter_init,
                masonry: {
                    columnWidth: '.grid_rea-sizer',
                    gutter: '.grid_rea-gutter-sizer',
                } 
            });
        });

       grid_isotope = $container_rea_masonry.isotope({
                itemSelector: '.resume-item-rea',
                percentPosition: true,
                filter:class_filter_init,
                masonry: {
                    columnWidth: '.grid_rea-sizer',
                    gutter: '.grid_rea-gutter-sizer',
                } 
        });




/******************************************************************/
/*************** ALL REAS - Gestion des filtres ********************/
/******************************************************************/

  // https://codepen.io/desandro/pen/DeGjdQ
    var filters = {};
    // do stuff when checkbox change
  $(".blockFilterAction input[type='checkbox']").on( 'change', function( jQEvent ){
    var $checkbox = $( jQEvent.target );
    manageCheckbox( $checkbox );

    var comboFilter = getComboFilter( filters );
    //console.log(comboFilter);
    grid_isotope.isotope({ filter: comboFilter });

  });
 

  function getComboFilter( filters ) {
  var i = 0;
  var comboFilters = [];
  var message = [];

  for ( var prop in filters ) {
    message.push( filters[ prop ].join(' ') );
    var filterGroup = filters[ prop ];
    // skip to next filter group if it doesn't have any values
    if ( !filterGroup.length ) {
      continue;
    }
    if ( i === 0 ) {
      // copy to new array
      comboFilters = filterGroup.slice(0);
    } else {
      var filterSelectors = [];
      // copy to fresh array
      var groupCombo = comboFilters.slice(0); // [ A, B ]
      // merge filter Groups
      for (var k=0, len3 = filterGroup.length; k < len3; k++) {
        for (var j=0, len2 = groupCombo.length; j < len2; j++) {
          filterSelectors.push( groupCombo[j] + filterGroup[k] ); // [ 1, 2 ]
        }

      }
      // apply filter selectors to combo filters for next group
      comboFilters = filterSelectors;
    }
    i++;
  }

  var comboFilter = comboFilters.join(', ');
  return comboFilter;
}

  function manageCheckbox( $checkbox ) {
    var checkbox = $checkbox[0];

    var group = $checkbox.parents('.option-set').attr('data-group');
    // create array for filter group, if not there yet
    var filterGroup = filters[ group ];
    if ( !filterGroup ) {
      filterGroup = filters[ group ] = [];
    }

    var isAll = $checkbox.hasClass('all');
    // reset filter group if the all box was checked
    if ( isAll ) {
      delete filters[ group ];
     
      if ( !checkbox.checked ) {
        checkbox.checked = 'checked';
      }
    }
    // index of
    var index = $.inArray('.'+checkbox.value, filterGroup );

    if ( checkbox.checked ) {
      var selector = isAll ? 'input.other' : 'input.all';
      $checkbox.parents('.option-set').find( selector ).removeAttr('checked');


      if ( !isAll && index === -1 ) {
        // add filter to group
        filters[ group ].push('.'+checkbox.value );
      }

    } else if ( !isAll ) {
      // remove filter from group
      filters[ group ].splice( index, 1 );
      // if unchecked the last box, check the all
        if ($checkbox.parents('.option-set').find('input:checked').length == 0) {
         $checkbox.parents('.option-set').find('input.all').prop('checked', true);
      }
    }

}

  
    // Search keyword ?
    //  $('form#recherche_produit').submit(function(event){
    //     event.preventDefault();
    //     var key_word = String($('input#keyword_name').val());
    //     if(key_word != ''){
          
    //         $('ul.products .product').removeClass('match');
    //          $('ul.products .product' ).each(function() {
    //            if ($(this).attr('class').match(new RegExp(key_word))) {
    //               $(this).addClass('match');
    //           }
    //         }); 
    //       grid_isotope.isotope({ filter: '.match' });
    //     }

    // });
  

  /******************************************************************/
/*************** CLKICK SUR OFFRE = OUVERTURE LIGHTBOX  ********************/
/******************************************************************/

  

     // ADD EVENT LIGHTBOX OFFER
    add_lightbox_offer(); 

     
      function add_lightbox_offer(){

        $('.js-open-info').featherlight('<div class="loader_js"></div>', {
            contentFilters: ["html"],
            closeIcon: '<i class="icon-close"></i>',
            afterContent : function(event){
              var $ID_OFFER = parseInt($(this.$currentTarget).attr('data-id-offer'));
              $.ajax({
                  type: 'POST',
                  url: object_var.ajaxurl,
                  data: { 
                      'action': 'call_offer',
                      'id_offer': $ID_OFFER // ICI VAR ID MUSEE
                  },
                  success: function(data){
            
                    $('.loader_js').hide(500, function(){
                      $('.featherlight-content').addClass('charge_off').append(data).hide().slideToggle(500);
                    
                    });
          
                  },error:function(error){
                    console.log('Erreur');
                  }
              });

            } // fin aftercontent

      }); // FIN FEATHERLIGTH

      }




}); 



